import { Col, Row } from "antd";
import { FileUploadItem } from "./constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";


const CDNFileDetail = () => {
	const { setCDNFileData } = useCDNFileContext();

	const handleFileChange = (fileData: FileData[] | null) => {
		setCDNFileData(prevState => ({
			...prevState,
			image: fileData?.[0]?.file || null
		}));
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20} key={FileUploadItem.key}>
					<FileUploadComponent
						title={FileUploadItem.label}
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData)}
						isRequired={FileUploadItem.isRequired}
						maxFileSize={FileUploadItem.maxFileSize}
						allowedExtensions={FileUploadItem.extensions}
					/>
				</Col>
			</Row>
		</>
	);
};

export default CDNFileDetail;
